/**
 * Anzeige der Einzelfreigaben eines Beitrags (content-api `shares`,
 * Alex 30.10.2026): wer darf mitlesen, wer hat es freigegeben.
 */

import type { PostShare } from '../types'

/** Anzeigename eines Freigabe-Empfängers: ohne Präfix, maskiert bleibt maskiert. */
export function shareName(principalId: string): string {
  const [kind, ...rest] = principalId.split(':')
  const value = rest.join(':')
  if (kind === 'user' && value === '***') return 'Person'
  return value || principalId
}

/** Tooltip: je Freigabe Empfänger, Stufe, von wem, seit wann. */
export function sharesTitle(shares: PostShare[]): string {
  return shares
    .map((s) => {
      const stufe = s.permission === 'write' ? 'bearbeiten' : 'lesen'
      const von = s.granted_by.replace(/^(agent|user):/, '')
      const seit = s.granted_at ? ` seit ${s.granted_at.slice(0, 10)}` : ''
      return `${shareName(s.principal_id)}: ${stufe}, freigegeben von ${von}${seit}`
    })
    .join('\n')
}
